import _ from 'lodash';
import {
  getProductsByNumberForSeasonAndNOS,
  filterProductByCluster,
  getProductsByNumber,
} from './products';
import { getCurrentOrder } from './orders';

const isProductMatchForSearch = ({ product, search }) => product.name.toUpperCase().includes(search ? search.toUpperCase() : []);

const doesProductBelongToSelectedClusters = ({
  clusters,
  includedInCluster,
  p,
  genre,
}) => {
  let productBelongsToClusters = includedInCluster;
  if (clusters || clusters === 'null') {
    productBelongsToClusters = filterProductByCluster({
      product: p,
      clusters,
    });
  }
  if (includedInCluster && genre) {
    productBelongsToClusters = filterProductByCluster({
      product: p,
      clusters: genre,
    });
  }
  return productBelongsToClusters;
};

const paginateProducts = ({ page, products, quantityPerPage }) => {
  const basePage = page - 1;
  let pages = Math.round(products.length / quantityPerPage);
  if (pages < 1) pages = 1;
  return {
    data: products.slice(0, basePage * quantityPerPage + quantityPerPage),
    pages,
  };
};

export const productsForSearchPageGenreAndClusters = (context) => (
  search = '',
  page = 1,
  genre,
  clusters,
) => {
  const currentOrder = getCurrentOrder(context);

  const season = _.get(currentOrder, 'doc.season');

  let productsByNumber;

  if (season) {
    productsByNumber = getProductsByNumberForSeasonAndNOS(context)(season);
  } else {
    productsByNumber = getProductsByNumber(context);
  }

  if (!productsByNumber) return null;
  const filtered = Object.values(productsByNumber).filter((p) => {
    let includedInCluster = true;
    includedInCluster = doesProductBelongToSelectedClusters({
      clusters,
      includedInCluster,
      p,
      genre,
    });

    if (!includedInCluster) return false;
    return isProductMatchForSearch({ product: p, search });
  });
  return paginateProducts({ page, products: filtered, quantityPerPage: 45 });
};
